module.exports = __webpack_public_path__ + "img/reg_back.cf20f310.png";